export function registerToast(Alpine) {
  Alpine.store('notify', {        // ✅ object langsung, bukan () => ({})
    toasts:  [],
    dialog:  null,
    dialogLoading: false,
    toast(type = 'info', title, message = '', duration = 4000) {
      const id = Date.now()
      this.toasts.push({ id, type, title, message })
      setTimeout(() => this.dismiss(id), duration)
    },
    success(title, message = '') { this.toast('success', title, message) },
    error(title, message = '')   { this.toast('error',   title, message) },
    warning(title, message = '') { this.toast('warning', title, message) },
    info(title, message = '')    { this.toast('info',    title, message) },

    dismiss(id) {
      this.toasts = this.toasts.filter(t => t.id !== id)
    },
    confirm(title, message, onConfirm, onCancel = null) {
      this.dialog = { title, message, onConfirm, onCancel }
    },
    async resolveDialog(confirmed) {
//      if (confirmed && this.dialog?.onConfirm) this.dialog.onConfirm()
//      if (!confirmed && this.dialog?.onCancel) this.dialog.onCancel()
//      this.dialog = null
  const cb = confirmed ? this.dialog?.onConfirm : this.dialog?.onCancel

  try {
  this.dialogLoading = true
    if (cb) await cb()        // tunggu callback selesai
  } finally {
  this.dialogLoading = false
    this.dialog = null        // baru tutup dialog
  }
    }
  })
}